import business from "../../assets/business.svg";
import gaming from "../../assets/gaming.svg";
import health from "../../assets/health.svg";
import investment from "../../assets/investment.svg";
import lifestyle from "../../assets/lifestyle.svg";
import music from "../../assets/music.svg";
import photography from "../../assets/photography.svg";
import design from "../../assets/figma.svg";
import writing from "../../assets/writing.svg";
import { getImageBaseUrl } from "../s3-utils";

export const getCategoryImage = (ctg = "") => {
  const category = ctg?.toLowerCase() || "";
  if (category.includes("health")) {
    return health;
  } else if (category.includes("business")) {
    return business;
  } else if (category.includes("gaming")) {
    return gaming;
  } else if (category.includes("investment") || category.includes("finance")) {
    return investment;
  } else if (category.includes("lifestyle")) {
    return lifestyle;
  } else if (category.includes("music")) {
    return music;
  } else if (category.includes("photography") || category.includes("content")) {
    return photography;
  } else if (category.includes("writing") || category.includes("academics")) {
    return writing;
  } else if (category.includes("design")) {
    return design;
  }

  return `${getImageBaseUrl}/assets/interest.svg`;
};
